import { render, staticRenderFns } from "./StoreCard.vue?vue&type=template&id=25292174&scoped=true&"
import script from "./StoreCard.vue?vue&type=script&lang=js&"
export * from "./StoreCard.vue?vue&type=script&lang=js&"
import style0 from "./StoreCard.vue?vue&type=style&index=0&id=25292174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25292174",
  null
  
)

export default component.exports